import { useRef } from 'react';
import moment from 'moment';

export function useStartDatetime() {
  const startDatetime = useRef<moment.Moment>();

  function setStartDatetime(datetime: moment.Moment) {
    startDatetime.current = datetime;
  }

  function getIsBeforeTour(): boolean {
    if (!startDatetime.current) {
      return false;
    }
    const currentDate = moment();
    if (startDatetime.current.diff(currentDate) > 60 * 1000 * 5) {
      return true;
    }
    return false;
  }

  function getIsAfterTour(): boolean {
    if (!startDatetime.current) {
      return false;
    }
    const currentDate = moment();
    if (currentDate.diff(startDatetime.current) > 60 * 1000 * 40) {
      return true;
    }
    return false;
  }

  return {
    startDatetime: startDatetime.current,
    setStartDatetime,
    getIsBeforeTour,
    getIsAfterTour,
  };
}
